/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react';
import { DataAPIClientError, UpdateReportParameters } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';

interface State {
  data?: string;
  error?: DataAPIClientError;
  isProcessing: boolean;
}

interface Result extends State {
  invoke: (reportID: string, params: UpdateReportParameters) => void;
}

export default function useDataAPIUpdateReport(): Result {
  const client = useDataAPIClient();

  const [state, setState] = useState<State>({ isProcessing: false });

  async function invoke(
    reportID: string,
    params: UpdateReportParameters
  ): Promise<void> {
    setState({ isProcessing: true });

    try {
      const data = await client.updateReport(reportID, params);

      setState({ data, isProcessing: false });
    } catch (error: any) {
      setState({ error, isProcessing: false });
    }
  }

  return { ...state, invoke };
}
